<template>
    <div>
        <Tab :tabItems="tabItems" @tabSelectHandler="tabSelectHandler" />
        <div class="common-info">
            <DateButtons
                v-if="!isMobile && (activeTab === 'orderHistory' || activeTab === 'tradeHistory' || activeTab === 'positionHistory')"
                :activeTab="activeTab" />
            <div v-else></div>

            <div class="input-box"
                v-if="!isMobile || (isMobile && activeTab !== 'orders' && activeTab !== 'orderHistory' && activeTab !== 'positions')">
                <input class="checkbox" type="checkbox" id="hideSymbol" v-model="hideOtherSymbol" />
                <label for="hideSymbol"></label>
                <span>{{$t('trading.table.hideSymbol')}}</span>
            </div>
        </div>

        <div class="tab-content">
            <Positions v-if="activeTab === 'positions'" />
            <OpenOrders v-if="activeTab === 'orders'" />
            <OrderHistory v-if="activeTab === 'orderHistory'" />
            <!-- <TradeHistory v-if="activeTab === 'tradeHistory'" /> -->
            <PositionHistory v-if="activeTab === 'positionHistory'" />
        </div>
        <ModalAlert :isVisible="alertDialog.isVisible" :content="alertDialog.content"
            @closeDialogHandler="alertDialog.isVisible = false" :is-btn="true" />
    </div>
</template>

<script setup>
import Tab from '../common/tab/Tab.vue';
import ModalAlert from '@/components/common/modal/ModalAlert.vue';
import DateButtons from '../common/date/DateButtons.vue';
import Positions from '@/components/trading/history/Position.vue';
import OpenOrders from '@/components/trading/history/OpenOrders.vue';
import OrderHistory from '@/components/trading/history/OrderHistory.vue';
// import TradeHistory from '@/components/trading/history/TradeHistory.vue';
import PositionHistory from '@/components/trading/history/PositionHistory.vue';
import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const alertDialog = ref({
    isVisible: false,
    content: ""
})
const store = useStore();
const tabItems = ref([
    {
        key: 'positions',
        value: t('trading.tab.positions'),
        isActive: true,
        isBeta: false,
    },
    {
        key: 'orders',
        value: t('trading.tab.oo'),
        isActive: false,
        isBeta: false,
    },
    {
        key: 'orderHistory',
        value: t('trading.tab.oh'),
        isActive: false,
        isBeta: false,
    },
    {
        key: 'tradeHistory',
        value: t('trading.tab.th'),
        isActive: false,
        isBeta: true,
    },
    {
        key: 'positionHistory',
        value: t('trading.tab.ph'),
        isActive: false,
        isBeta: false,
    },
]);
const isMobile = computed(() => store.state.account.isMobile);
const hideOtherSymbol = computed({
    get: () => store.state.user_history.hideOtherSymbol,
    set: (value) => store.commit('user_history/setHideOtherSymbol', value)
})
const activeTab = computed(() => {
    return tabItems.value.find(t => t.isActive)?.key ?? '';
});
const tabSelectHandler = (payload) => {
    const clicked = tabItems.value.find(t => t.key === payload);
    if (clicked && clicked?.isBeta) {
        alertDialog.value.isVisible = true;
        alertDialog.value.content = t('trading.tab.soon');
        return;
    }
    tabItems.value.forEach(t => {
        t.isActive = (t.key === payload);
    });
}
</script>

<style lang="scss" scoped>
.common-info {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
}

.input-box {

    justify-content: flex-end;
}

.tab-content {
    height: calc((100% - 50px));
    overflow: auto;
    padding-bottom: 10px;
    padding-inline-end: 8px;
    @media screen and (max-width:480px) {
        height: calc((100% - 90px));
    }
}

.tab-content::-webkit-scrollbar {
    width: 4px;
    height: 8px;
    background: transparent;
}

.tab-content::-webkit-scrollbar-thumb {
    background-color: var(--btn-color);
    border-radius: 4px;
}

@media screen and (max-width:1024px) {
    /* .tab-content {
        height: calc((100% - 50px));
    } */
}
</style>